<template>
  <v-navigation-drawer
    :value="drawer"
    @input="update"
    app
    temporary
    class="d-flex flex-wrap flex-column"
  >
    <v-list dense nav class="pb-10" v-if="allCategories.length > 0">
      <v-list-item>
        <v-list-item-content>
          <v-img width="175" src="/img/teamhive-logohz-sitenav.svg"></v-img>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/" exact @click.native="$gtag.clickButton('Home')">
        <v-list-item-icon>
          <v-icon>mdi-home</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Home</v-list-item-content>
      </v-list-item>
      <v-list-group prepend-icon="mdi-television" no-action>
        <template v-slot:activator>
          <v-list-item-title>Watch</v-list-item-title>
        </template>
        <v-list-item to="/broadcasts" exact @click.native="$gtag.clickButton('See More Broadcasts')">
          <v-list-item-content>All Categories</v-list-item-content>
          <v-list-item-icon>
            <v-icon>mdi-view-grid</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-group sub-group no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>High School</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item exact :to="urlByCategoryId(1)" @click.native="$gtag.clickButton(nameByCategoryId(1))">
            <v-list-item-content>All</v-list-item-content>
          </v-list-item>
          <v-list-item
            exact
            v-for="category in highSchoolCategories"
            :key="category.name + category.id"
            :to="'/broadcasts/' + category.id + '/' + seoName(category.name)"
            @click.native="$gtag.clickButton(category.name)"
          >
            <v-list-item-content>{{ category.name }}</v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item
          v-for="item in noSubItems"
          :key="item.name + item.id"
          exact
          :to="urlByCategoryId(item.id)"
          @click.native="$gtag.clickButton(item.name)"
        >
          <v-list-item-content>{{ item.name }}</v-list-item-content>
          <v-list-item-icon>
            <v-icon>mdi-play-box</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-group sub-group no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Local Shows</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item exact :to="urlByCategoryId(4)" @click.native="$gtag.clickButton(nameByCategoryId(4))">
            <v-list-item-content>All</v-list-item-content>
          </v-list-item>
          <v-list-item
            exact
            v-for="category in localCategories"
            :key="category.name + category.id"
            :to="'/broadcasts/' + category.id + '/' + seoName(category.name)"
            @click.native="$gtag.clickButton(category.name)"
          >
            <v-list-item-content>{{ category.name }}</v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list-group>
      <v-list-group prepend-icon="mdi-bell-outline" no-action>
        <template v-slot:activator>
          <v-list-item-title>Schools</v-list-item-title>
        </template>
        <v-list-item exact :to="urlByCategoryId(1)" @click.native="$gtag.clickButton(nameByCategoryId(1))">
          <v-list-item-content>All</v-list-item-content>
        </v-list-item>
        <v-list-item
          exact
          v-for="category in highSchoolCategories"
          :key="category.name + category.id"
          :to="'/broadcasts/' + category.id + '/' + seoName(category.name)"
          @click.native="$gtag.clickButton(category.name)"
        >
          <v-list-item-content>{{ category.name }}</v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item to="/advertise" @click.native="$gtag.clickButton('Advertise');">
        <v-list-item-icon>
          <v-icon>mdi-bullhorn-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Advertise</v-list-item-content>
      </v-list-item>
      <v-list-item to="/signup" @click.native="$gtag.clickButton('Get Notified');">
        <v-list-item-icon>
          <v-icon>mdi-bell</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Get Notified</v-list-item-content>
      </v-list-item>
      <v-list-item to="/contact" @click.native="$gtag.clickButton('Contact Us');">
        <v-list-item-icon>
          <v-icon>mdi-email</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Contact Us</v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import broadcastCategoriesMixin from '../mixins/broadcastCategoriesMixin';
import seoNameMixin from '../mixins/seoNameMixin';
export default {
  mixins: [broadcastCategoriesMixin, seoNameMixin],
  props: {
    drawer: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({}),
  methods: {
    update(val) {
      this.$emit('updated', val);
    },
  },
};
</script>
<style scoped>
.v-navigation-drawer {
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
}
</style>
